var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    {
      attrs: { show: _vm.show },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Exportar a CRM" },
        on: { cerrar: _vm.closeModal }
      }),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Detalle")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c(
            "div",
            { staticClass: "orden_compra", attrs: { align: "center" } },
            [
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _vm.id_orden_compra != null
                                ? _c("h1", [
                                    _vm._v(
                                      "\n                Exportar a CRM Orden de Compra: " +
                                        _vm._s(_vm.id_orden_compra) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "FormFieldsContainer",
                                { attrs: { titulo: "Exportar" } },
                                [
                                  _c("v-divider"),
                                  _c("br"),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs12: "",
                                        sm12: "",
                                        md12: "",
                                        layout: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "divP",
                                          attrs: { align: "left" }
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "aclaracion" },
                                            [
                                              _vm._v(
                                                "\n                      Se recomienda utilizar el formato de la siguiente\n                      plantilla para evitar conflictos al momento de cargar la\n                      solicitud.\n                      "
                                              ),
                                              _c("br"),
                                              _vm._v(
                                                "\n                      Por favor, ingresar los datos según los formatos que se\n                      muestran en la fila de ejemplo de la plantilla.\n                    "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "btnPlantilla",
                                              staticStyle: {
                                                padding: "0",
                                                "margin-left": "0"
                                              },
                                              attrs: {
                                                flat: "",
                                                small: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: _vm.descargarPlantilla
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "importExportBtnIcon"
                                                },
                                                [_vm._v("cloud_download")]
                                              ),
                                              _vm._v(
                                                "  \n                      "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "importExportBtnTexto"
                                                },
                                                [_vm._v("Descargar Plantilla")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }